import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'
// Removed Col, Collapse, message imports
import { API } from 'aws-amplify'
import moment from 'moment'
import { useEffect, useState } from 'react'
import badge from '../../../images/stripe-badge-transparent.png'
import { useGlobalState } from '../../../store'
import { useLocalization } from '../../../localization'; // Added localization hook
import {
  CBButton,
  CBHeader,
  CBInput,
  CBRadioGroup,
  CBRadioGroupBig,
  CurrentPlan,
  SubmitButton,
  CBAlert // Added CBAlert for message replacement (optional)
} from '../../core/components/cbd'
// Removed Panel destructuring

const v2_plans = {
  basic: {
    monthly: { value: 5, planId: process.env.REACT_APP_STRIPE_MONTHLY_BASIC_PLAN, fullPrice: 6, book: 5, },
    yearly: { value: 4, planId: process.env.REACT_APP_STRIPE_YEARLY_BASIC_PLAN, fullPrice: 5, book: 5, },
  },
  premium: {
    monthly: { syncs: 16, value: 10, planId: process.env.REACT_APP_STRIPE_MONTHLY_PREMIUM_PLAN, fullPrice: 12, book: 5, },
    yearly: { syncs: 16, value: 8, planId: process.env.REACT_APP_STRIPE_YEARLY_PREMIUM_PLAN, fullPrice: 10, book: 5, },
  },
  pro: {
    monthly: { syncs: 36, value: 20, planId: process.env.REACT_APP_STRIPE_MONTHLY_PRO_PLAN, fullPrice: 24, book: 10, },
    yearly: { syncs: 36, planId: process.env.REACT_APP_STRIPE_YEARLY_PRO_PLAN, fullPrice: 20, book: 10, },
  },
};
const v3_plans = {
   basic: {
    monthly: { syncs: 2, value: 5, planId: process.env.REACT_APP_STRIPE_MONTHLY_BASIC_PLAN, fullPrice: 6, book: 10, },
    yearly: { syncs: 2, value: 4, planId: process.env.REACT_APP_STRIPE_YEARLY_BASIC_PLAN, fullPrice: 5, book: 10, },
  },
  premium: {
    monthly: { syncs: 16, value: 10, planId: process.env.REACT_APP_STRIPE_MONTHLY_PREMIUM_PLAN, fullPrice: 12, book: 10, },
    yearly: { syncs: 16, value: 8, planId: process.env.REACT_APP_STRIPE_YEARLY_PREMIUM_PLAN, fullPrice: 10, book: 10, },
  },
  pro: {
    monthly: { syncs: 36, value: 40, planId: process.env.REACT_APP_STRIPE_MONTHLY_PRO_V3_PLAN, fullPrice: 48, book: 10, },
    yearly: { syncs: 36, value: 32, planId: process.env.REACT_APP_STRIPE_YEARLY_PRO_v3_PLAN, fullPrice: 40, book: 10, },
  },
};


const BillingForm = ({
  isLoading, // Keep isLoading prop
  successMessage = null, // Default will be handled by localization
  reloadAfterSuccess = true,
  showPlan = false,
  showCard = false,
  showCurrentPlan = false,
  syncs = 0,
  schedules = 0,
  onCancel,
  onRestore,
}) => {
  const { t } = useLocalization(); // Initialize localization hook
  const [user] = useGlobalState('user')
  const [license, setLicense] = useGlobalState('license')
  const [isProcessing, setIsProcessing] = useState(false)
  const successMessageLocalized = successMessage || t('billingForm.successMessageDefault'); // Use prop or default localized
  const [showReferral, setShowReferral] = useState(false)
  const [isCardComplete, setIsCardComplete] = useState(false)
  const [attemptedSubmission, setAttemptedSubmission] = useState(false)
  const [isYearlyPlan, setIsYearlyPlan] = useState(
    license.planId.includes('yearly')
  )
  const [actionShowPlan, setActionShowPlan] = useState(license.trial)
  const [actionShowCard, setActionShowCard] = useState(license.trial)
  const [actionShowButton, setActionShowButton] = useState(
    license.trial || (!license.active && license.wasDeactivated)
  )
  const [referralCode, setReferralCode] = useState('')
  const [plan, setPlan] = useState(getPlanState())
  const [cardError, setCardError] = useState(null)
  const [plans, setPlans] = useState(
    license.v3limit != null && license.v3limit ? v3_plans : v2_plans
  )

  useEffect(() => {
    setPlans(license.v3limit != null && license.v3limit ? v3_plans : v2_plans)
  }, [license])

  function getPlanState() {
    var state = ''
    if (license.trial) {
      state = 'premium'
    } else if (
      license.planId == 'calendarbridge-test' ||
      license.planId == 'calendarbridge-pro'
    ) {
      state = 'premium'
    } else {
      // Safely handle potential missing '-'
      const parts = license.planId?.split('-') || [];
      state = parts[0] || 'basic'; // Default to basic if split fails
    }
    return state
  }

  function trailing_zeros(number) {
    number = number.toFixed(2);
    return number
  }

  const stripe = useStripe()
  const elements = useElements()

  function validateForm() {
    return !attemptedSubmission || !actionShowCard || isCardComplete
  }

  async function handleSubmitClick(event) {
    // event.preventDefault() // Not needed if button type isn't submit

    setIsProcessing(true)
    setAttemptedSubmission(true)
    setCardError(null)
    if (!stripe || !elements) {
      alert( // Replaced message.error
        t('billingForm.submitErrorGeneral')
      )
      setIsProcessing(false)
      return
    }

    let token = null
    if (actionShowCard || showCard || license.trial) {
      const cardElement = elements.getElement(CardElement)
      if (!cardElement) {
          alert(t('billingForm.submitErrorCardComponent'));
          setIsProcessing(false);
          return;
      }

      const resp = await stripe.createToken(cardElement)
      if (resp.error) {
        alert(resp.error.message); // Replaced message.error
        setIsProcessing(false)
        return
      }
      token = resp.token
    }

    var planId = ""
    if(plan == "admin") {
      if(isYearlyPlan) {
        planId = process.env.REACT_APP_STRIPE_YEARLY_ADMIN_PLAN
      } else {
        planId = process.env.REACT_APP_STRIPE_MONTHLY_ADMIN_PLAN
      }
    } else {
       // Ensure plan exists in the plans object
       if (plans[plan] && plans[plan][isYearlyPlan ? 'yearly' : 'monthly']) {
           planId = plans[plan][isYearlyPlan ? 'yearly' : 'monthly']['planId'];
       } else {
           console.error("Selected plan details not found:", plan, isYearlyPlan);
           alert(t('billingForm.submitErrorPlanSelection'));
           setIsProcessing(false);
           return;
       }
    }

    try {
      const resp = await API.post('billing', '/billing', {
        body: {
          token: token ? token.id : undefined,
          email: user.username,
          referralCode: actionShowCard || showCard ? referralCode : undefined,
          plan: planId,
        },
        response: true,
      })
      const wasTrial = license.trial
      setLicense(resp.data.license)

      if (wasTrial) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'dashboardEvent', category: 'userActivity', action: 'pay',
          label: resp.data.license.userId, email: resp.data.license.email,
        })
        window.dataLayer.push({
          event: 'dashboardEvent', category: 'userActivity', action: 'new_' + resp.data.license.planId,
          label: resp.data.license.userId, email: resp.data.license.email,
        })
      }

      setIsProcessing(false)
      // alert(successMessageLocalized); // Use localized success message
      if (reloadAfterSuccess) {
        window.location.reload()
      }
    } catch (ex) {
      console.error("Billing submission failed:", ex);
      setIsProcessing(false)
      if (ex.response) {
        const errorMessage = ex.response?.data?.message || t('billingForm.submitErrorUnexpected');
        setCardError(errorMessage) // Keep setting cardError state
        alert(t('billingForm.submitErrorApi', { message: errorMessage })); // Also show alert
      } else {
        alert(t('billingForm.submitErrorUnexpected')); // Generic alert
      }
    }
  }
  function capitalizeFirstLetter(string) {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
  const currentPlanLabel = getPlanState()
  const currentPlanIntervalYearly = license.planId.includes('yearly')

  // Safely access plan details
  const currentPlanDetails = plans[currentPlanLabel]?.[currentPlanIntervalYearly ? 'yearly' : 'monthly'];

  return (
    <>
      {showCurrentPlan && (
        <div className="mb-4">
          <CBHeader label={t('billingForm.currentPlanHeader')}></CBHeader>
          {currentPlanLabel != 'admin' && currentPlanDetails && ( // Check if details exist
            <CurrentPlan
              primary={
                <div className="font-sarabun lg:text-xl text-neutral_4 mb-3">
                  <b>
                    {capitalizeFirstLetter(currentPlanLabel)} -{' '}
                    {currentPlanIntervalYearly ? t('billingForm.yearly') : t('billingForm.monthly')}{' '}
                    {license.trial && (
                      <div className="font-sarabun lg:text-lg text-burnt">
                        {t('billingForm.trialExpires', { time: moment(license.trialStarted).add(7, 'day').fromNow() })}
                      </div>
                    )}
                  </b>
                </div>
              }
              secondary={
                <div className="font-sarabun flex flex-col gap-y-4">
                  {license.state.includes('cancel_at_end') && (
                    <div className="text-xl text-burnt">{t('billingForm.cancelledStatus')}</div>
                  )}
                  <div className="text-lg">
                    <b>{t('billingForm.syncsUsed', { syncs: syncs, totalSyncs: currentPlanDetails.syncs })}</b>
                  </div>
                  <div className="text-lg">
                    <b>{t('billingForm.schedulesUsed', { schedules: schedules, totalSchedules: currentPlanDetails.book })}</b>
                  </div>
                  {license.planId != 'calendarbridge-test' &&
                    license.planId != 'calendarbridge-pro' &&
                    isYearlyPlan &&
                    !license.trial && (
                      <div className="text-neutral_4 text-lg">
                        <b>{t('billingForm.chargedPerYear', { amount: currentPlanDetails.value * 12 })}</b>
                      </div>
                    )}
                  {license.planId != 'calendarbridge-test' &&
                    license.planId != 'calendarbridge-pro' &&
                    !license.trial &&
                    !currentPlanIntervalYearly && (
                      <div className="text-neutral_4 text-lg">
                        <b>{t('billingForm.chargedPerMonth', { amount: currentPlanDetails.value })}</b>
                      </div>
                    )}
                  {(license.planId == 'calendarbridge-test' ||
                    license.planId == 'calendarbridge-pro') &&
                    !license.trial &&
                    !currentPlanIntervalYearly && (
                      <div className="text-neutral_4 text-lg">
                        <b>{t('billingForm.chargedPerMonthLegacy')}</b>
                      </div>
                    )}
                </div>
              }
            />
          )}
          {license.trial && license.active && (
            <div className="flex flex-row gap-4 font-sarabun mt-2 justify-end">
              <CBButton onClick={(e) => onCancel()} type="ternary">
                {t('billingForm.cancelTrialButton')}
              </CBButton>
            </div>
          )}
          {!license.trial && !license.state.includes('cancel_at_end') && (
            <div>
              <div className="relative">
                <div className="flex flex-col lg:flex-row mt-4 gap-4 lg:absolute lg:-top-8 lg:right-0">
                  <div>
                    <CBButton
                      type="primary"
                      disabled={license.stripeUserId == 'site'}
                      onClick={(e) => {
                        setActionShowButton(true)
                        setActionShowCard(true)
                        setActionShowPlan(false)
                      }}
                    >
                      {t('billingForm.updatePaymentButton')}
                    </CBButton>
                  </div>
                  <div>
                    <CBButton
                      disabled={license.orgAdmin || license.stripeUserId == 'site'}
                      onClick={(e) => {
                        setActionShowButton(true)
                        setActionShowCard(false)
                        setActionShowPlan(true)
                      }}
                      type="ternary"
                    >
                      {t('billingForm.changePlanButton')}
                    </CBButton>
                  </div>
                  <div>
                    <CBButton
                      disabled={license.orgAdmin || license.stripeUserId == 'site'}
                      onClick={(e) => onCancel()}
                      type="ternary"
                    >
                      {t('billingForm.cancelSubscriptionButton')}
                    </CBButton>
                  </div>
                </div>
              </div>
            </div>
          )}
          {!license.trial && license.state.includes('cancel_at_end') && (
            <div className="flex mt-4 gap-x-4">
              <div>
                <CBButton onClick={(e) => onRestore()} type="ternary">
                  {t('billingForm.restoreSubscriptionButton')}
                </CBButton>
              </div>
            </div>
          )}
          {license.orgAdmin && (
                  <div className="flex flex-col mt-12 text-right text-sm"> {/* Adjusted size */}
                    <div>
                      {t('billingForm.orgAdminNote')}{' '}
                      <a href="/dashboard/organization" className="text-blue-600 hover:underline">{t('billingForm.orgAdminLink')}</a>
                    </div>
                  </div>
                )}
        </div>
      )}
      {actionShowPlan && (
        <>
          {license.trial && (
            <CBHeader label={t('billingForm.upgradeHeader')}></CBHeader>
          )}{' '}
          {!license.trial && <CBHeader label={t('billingForm.selectPlanHeader')}></CBHeader>}
        </>
      )}
      {(actionShowPlan || showPlan) && (
        <div className="flex flex-col mb-4">
          <CBRadioGroup
            title={t('billingForm.billingPeriodTitle')}
            selected={isYearlyPlan ? 1 : 0}
            labels={[t('billingForm.monthly'), t('billingForm.yearly')]}
            values={['monthly', 'yearly']}
            onChange={( val) => { // Use index or value
              console.log(val)
              setIsYearlyPlan(val === 1);
            }}
            className="mb-4" // Add margin
          />
          <CBRadioGroupBig
            id="plan-selection" // Added id
            title={t('billingForm.plansTitle')}
            collapsible={false}
            selected={plan == 'premium' ? 1 : plan == 'pro' ? 2 : 0}
            values={Object.keys(plans)} // Pass keys as values
            labels={Object.keys(plans).map((e) => (
              <div className="font-sarabun text-2xl">{t(`billingForm.plan${capitalizeFirstLetter(e)}`)}</div>
            ))}
            subLabels={Object.values(plans).map((planDetails) => {
              const details = planDetails[isYearlyPlan ? 'yearly' : 'monthly'];
              if (!details) return null; // Handle missing plan details
              return (
                <div className="font-sarabun text-neutral_half flex flex-col gap-2 text-lg">
                  <div className="text-neutral_4 text-lg">
                    <b>{t('billingForm.chargedPerMonth', { amount: details.value })}</b>
                  </div>
                  <div className="text-burnt text-lg">
                    <b>{details.syncs} Sync Connections</b>
                  </div>
                  <div>{t('billingForm.unlimitedAccounts')}</div>
                  <div>{details.book} booking links</div>
                  {isYearlyPlan && (
                    <div className="text-neutral_4 text-md">
                      <b>{t('billingForm.yearlySave', { amount: details.value * 12, savedAmount: details.fullPrice - details.value })}</b>
                    </div>
                  )}
                </div>
              )
            })}
            onChange={(val) => {
              switch (val) {
                case 0:
                  setPlan('basic')
                  break
                case 1:
                  setPlan('premium')
                  break
                case 2:
                  setPlan('pro')
                  break
              } // Set plan based on value (key)
            }}
          />
        </div>
      )}
      <form className="BillingForm" onSubmit={(e) => { e.preventDefault(); handleSubmitClick(); }}> {/* Prevent default form submission */}
        {(actionShowCard || showCard) && (
          <div style={{ maxWidth: 400 }} className="mb-4"> {/* Added margin */}
            <CBHeader label={t('billingForm.paymentInfoHeader')}></CBHeader>
            <CardElement
              onChange={(e) => {
                if (cardError) setCardError(null);
                setIsCardComplete(e.complete);
              }}
              options={{
                style: {
                  base: { fontSize: '18px', fontFamily: '"Open Sans", sans-serif' },
                },
              }}
              className="p-3 border rounded" // Added basic styling
            />
          </div>
        )}
        {validateForm() && cardError && (
           <CBAlert variant="error" message={cardError} className="my-2" /> // Use CBAlert
        )}
        {!validateForm() && (
          <p className="font-sarabun ml-4 mt-4 text-red-600 text-sm"> {/* Use Tailwind */}
            {t('billingForm.cardValidationHint')}
          </p>
        )}

        {/* Conditional rendering for charge amount */}
        { (license.trial || ( (actionShowPlan || showPlan || actionShowCard || showCard) && license.planId !== `${plan}-${isYearlyPlan ? 'yearly' : 'monthly'}` && license.planId !== 'calendarbridge-test' && license.planId !== 'calendarbridge-pro' )) && plans[plan]?.[isYearlyPlan ? 'yearly' : 'monthly'] && (
            <div className="font-sarabun mt-8 ml-2 text-lg"> {/* Adjusted size */}
              {t('billingForm.chargeAmountLabel')}{' '}
              {license.partner ? (
                  <div>
                    $<b>{trailing_zeros(plans[plan][isYearlyPlan ? 'yearly' : 'monthly'].value * (isYearlyPlan ? 12 : 1) * 0.6)}</b>
                    {' '}{isYearlyPlan ? t('billingForm.perYear') : t('billingForm.perMonth')} {t('billingForm.forFirstYear')},{' '}
                    <b>${trailing_zeros(plans[plan][isYearlyPlan ? 'yearly' : 'monthly'].value * (isYearlyPlan ? 12 : 1))}</b>
                    {' '}{isYearlyPlan ? t('billingForm.perYear') : t('billingForm.perMonth')} {t('billingForm.afterFirstYear')}
                  </div>
              ) : (
                  <> {/* Use fragment */}
                    <b>${trailing_zeros(plans[plan][isYearlyPlan ? 'yearly' : 'monthly'].value * (isYearlyPlan ? 12 : 1))}</b>
                    {' '}{isYearlyPlan ? t('billingForm.perYear') : t('billingForm.perMonth')}
                  </>
              )}
            </div>
        )}

        <div className="flex flex-col mt-4">
          {license.trial && <a className="ml-2 text-sm text-blue-600 hover:underline cursor-pointer" onClick={e=> setShowReferral(!showReferral)}>{!showReferral ? t('billingForm.haveReferralCodeLink') : t('billingForm.hideReferralFormLink')}</a>}
          {license.trial && !license.partner && showReferral && (
            <div style={{ marginTop: 4 }}>
               {/* Replaced Col with div */}
              <div className="w-full md:w-1/2"> {/* Approx span={10} */}
                <div className="font-sarabun border-0"> {/* Removed Panel styling */}
                  <CBInput
                    label={t('billingForm.referralCodeLabel')} // Added label
                    hint={t('billingForm.referralCodeHint')}
                    value={referralCode}
                    maxLength={10}
                    onChange={(e) => { setReferralCode(e) }}
                    className="mb-2" // Added margin
                  />
                  <small className="font-sarabun text-xs"> {/* Adjusted size */}
                    {t('billingForm.referralAcceptText')}{' '}
                    <a href="https://help.calendarbridge.com/referral-program-terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                      {t('billingForm.referralTermsLink')}
                    </a>
                  </small>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="h-4"></div>
        {actionShowButton && (
          <SubmitButton
            size="large"
            type="primary"
            onClick={(e) => handleSubmitClick()} // Pass event if needed by handler
            loading={isProcessing || isLoading}
            disabled={!validateForm() || isProcessing}
            className="mt-5" // Replaced style
          >
            {actionShowPlan || showPlan
              ? t('billingForm.subscribeButton')
              : t('billingForm.updateCardButton')}
          </SubmitButton>
        )}
        {license.partner && <div className="text-sm mt-2"><b>{t('billingForm.partnerDiscountApplied')}</b></div>}


        {actionShowCard && (
          <div className="mt-12 flex justify-center"> {/* Use flex for centering */}
            <img src={badge} alt={t('billingForm.stripeAltText')} /> {/* Added alt */}
          </div>
        )}
      </form>

    </>
  )
}

export default BillingForm;
